import { render, staticRenderFns } from "./ValidatorPrompt.vue?vue&type=template&id=35f2a248&"
import script from "./ValidatorPrompt.vue?vue&type=script&lang=js&"
export * from "./ValidatorPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports